import {Chapter as template, ChapterCard as cardTemplate} from 'templates/components/chapter';


export {Chapter, ChapterElement} from './Chapter';


export const chapterRegistrations = {
    'Chapter': { template },
    'ChapterCard': { template: cardTemplate }
};
